//
// Header.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./SectionRepeat";
import "./MediaContainer";
import "./HeaderLocation";

var Header = createModule("BIRD::Header", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        repeat: 4,
        width: 7,
        location: 4,
        mediaContainers: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Header;
